import React from "react";
import { makeStyles } from "@mui/styles";
import { MailProDialog } from "views/Pma/MailPro/components/MailProDialog/MailProDialog";
import { MailProDialogHeader } from "views/Pma/MailPro/components/MailProDialog/MailProDialogHeader";
import { MailProDialogBody } from "views/Pma/MailPro/components/MailProDialog/MailProDialogBody";
import MailProButton from "views/Pma/MailPro/components/UI/MailProButton";
import { DIALOG_BUTTON_BORDER_RADIUS, DIALOG_BUTTON_MIN_HEIGHT } from "./constants";
import MiniTableProCore from "./MiniTableProCore";

const useStyles = makeStyles({
  dialogPaper: {
    maxWidth: "1063px",
    width: "99vw",
    "& .MuiDialogContent-root": {
      padding: "0 !important",
    },
  },
  dialogHeader: {
    backgroundColor: "#4A7396",
    color: "white",
    padding: "8px 24px",
    textAlign: "center",
    width: "100%",
  },
  headerTitle: {
    fontSize: "24px",
    fontWeight: "bold",
    fontFamily: "objektiv-mk2, sans-serif",
    textAlign: "center",
  },
  headerSubtitle: {
    fontSize: "16px",
    fontFamily: "objektiv-mk2, sans-serif",
    textAlign: "center",
    opacity: 0.95,
  },
  dialogBody: {
    padding: "24px 120px 24px 24px",
    maxHeight: "70vh",
    overflowY: "auto",
    overflowX: "hidden",
  },
  tableWrap: {
    maxWidth: "959px",
    width: "100%",
    margin: "0 auto",
  },
  dialogFooter: {
    padding: "16px 24px",
    background: "#f9fafb",
    borderTop: "1px solid #e5e7eb",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "stretch",
  },
  dialogFooterActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "12px",
    width: "100%",
  },
});

/**
 * Dialog for editing properties in the mini table.
 * Opens when user clicks "EDIT a Property" in EditTableButtonsDialog.
 * Same layout/style as Delete Property Dialog; table in edit mode with Edit buttons.
 * Footer has Cancel only — closes dialog and resets edit mode.
 */
export default function EditPropertyDialog({
  open,
  onClose,
  areaName = "",
  properties = [],
  onEditPropertyClick,
  maxRows,
  currentArea,
  quarterlyAreaTable,
  agentData,
}) {
  const classes = useStyles();

  const handleCancel = () => {
    onClose?.();
  };

  return (
    <MailProDialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }}>
      <MailProDialogHeader>
        <div className={classes.dialogHeader}>
          <div className={classes.headerTitle}>{areaName}</div>
          <div className={classes.headerSubtitle}>Select any property to EDIT</div>
        </div>
      </MailProDialogHeader>
      <MailProDialogBody>
        <div className={`${classes.dialogBody} mini-table-dialog-body`}>
          <div className={classes.tableWrap}>
            <MiniTableProCore
              miniTableProperties={properties}
              printVersion={false}
              hideTitleAndSubtitle={true}
              editMode={true}
              onEditPropertyClick={onEditPropertyClick}
              maxRows={maxRows}
              currentArea={currentArea}
              quarterlyAreaTable={quarterlyAreaTable}
              agentData={agentData}
            />
          </div>
        </div>
      </MailProDialogBody>
      <div className={classes.dialogFooter}>
        <div className={classes.dialogFooterActions}>
          <MailProButton
            variant="outlined"
            label="Close"
            onClick={handleCancel}
            customStyle={{
              fontSize: "12px",
              padding: "6px 14px",
              textTransform: "uppercase",
              fontWeight: "bold",
              minWidth: "auto",
              borderRadius: DIALOG_BUTTON_BORDER_RADIUS,
              minHeight: DIALOG_BUTTON_MIN_HEIGHT,
              height: DIALOG_BUTTON_MIN_HEIGHT,
              boxSizing: "border-box",
            }}
          />
        </div>
      </div>
    </MailProDialog>
  );
}
